import {select} from "../../store";
import {createRouteGuard} from "../../routers/createRouteGuard";

export const AdminIsLoggedIn = createRouteGuard({
  authenticatedSelector: select.adminSession.isLoggedIn,
  redirectPath: "/admin",
});
